import HTTPError from 'errors/HTTPError';

const createFirebaseClient = auth => {
  const request = ({ method = 'GET', path, body }) =>
    Promise.all([auth.getOriginalToken(), auth.getAccountId()])
      .then(([token, accountId]) =>
        fetch(
          /* global FIREBASE_NAMESPACE */
          `https://${FIREBASE_NAMESPACE}.firebaseio.com/accounts/${accountId}/${path}.json?auth=${token}`,
          {
            method,
            headers: {
              'Content-Type': 'application/json',
            },
            ...(body && { body: JSON.stringify(body) }),
          }
        )
      )
      .then(response => {
        if (!response.ok) {
          throw new HTTPError(`failed to fetch ${path}`);
        }
        return response.json();
      });

  const getSegment = id => request({ path: `segments/${id}` });

  const updateSegment = (id, body) =>
    request({ method: 'PATCH', path: `segments/${id}`, body }).then(() =>
      getSegment(id)
    );

  return {
    getAllSegments: () =>
      request({ path: `segments` }).then(segments =>
        segments ? Object.values(segments) : []
      ),
    getSegment,
    updateSegment,
    deleteSegment: id =>
      request({ method: 'DELETE', path: `segments/${id}` }).then(() => ({
        ok: true,
      })),
    createSegment: body =>
      request({ method: 'POST', path: `segments`, body }).then(({ name: id }) =>
        updateSegment(id, { id })
      ),
  };
};

export default createFirebaseClient;
